import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import Loader from "../../Components/Loader";
import masterServices from "../../Services/masterService";
import helperFunction from "../../Function/helperFunction";

const DutyAndTaxCalculator = () => {
  const history = useHistory();
  const [loader, setLoader] = useState();
  const [data, setData] = useState([]);

  // const formik = useFormik({
  const initialValues = {
    cost: "",
    insurance: "",
    freight: "",
    cif: "",
    duty: "",
    duty_amt: "",
    vat: "",
    vat_amt: "",
    duty_vat_amt: "",
    caf: "",
    additional_fee: "",
    duty_tax: "",
  };

  const validationSchema = Yup.object({
    cost: Yup.string().required("Required"),
    insurance: Yup.string().required("Required"),
    freight: Yup.string().required("Required"),
    cif: Yup.string().required("Required"),
    duty: Yup.string().required("Required"),
    duty_amt: Yup.string().required("Required"),
    vat: Yup.string().required("Required"),
    vat_amt: Yup.string().required("Required"),
    duty_vat_amt: Yup.string().required("Required"),
    caf: Yup.string().required("Required"),
    additional_fee: Yup.string().required("Required"),
    duty_tax: Yup.string().required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {},
  });

  const getData = async () => {
    await masterServices
      .get_marketplace()
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const {
    values,
    errors,
    touched,
    getFieldProps,
    handleSubmit,
    setFieldValue,
    setValues
  } = formik;

  console.log(data, "data")

  useEffect(() => {
    data &&
    values.cost &&
        setFieldValue(
          "insurance",
          Number(values.cost * data?.duty_tax_insurance_per) / 100 
        ) ||
        setFieldValue("insurance", "0") 
        ;
    // }
    setFieldValue("freight", helperFunction.fixedDesimalNumber(Number(values.cost * data?.duty_tax_freight_per || 0) / 100));
    setFieldValue("additional_fee", helperFunction.fixedDesimalNumber(Number(data?.duty_tax_additional_charge || 0)));
    setFieldValue(
      "cif",
      helperFunction.fixedDesimalNumber(
      Number(values.cost) + Number(values.insurance) + Number(values.freight)
    )
    );
    setFieldValue("duty_amt", helperFunction.fixedDesimalNumber(Number(values.cif) * (Number(values.duty) / 100)));
    setFieldValue(
      "vat_amt",
      helperFunction.fixedDesimalNumber(
        (Number(values.cif) + Number(values.duty_amt)) *
          (Number(values.vat) / 100)
      )
    );
    setFieldValue(
      "duty_vat_amt",
      helperFunction.fixedDesimalNumber(
      Number(values.duty_amt) + Number(values.vat_amt))
    );
    setFieldValue("caf", helperFunction.fixedDesimalNumber((Number(values.duty_vat_amt) * Number(data?.caf || 0)) / 100));
    {
      values.duty_vat_amt > 0 &&
      setFieldValue(
        "duty_tax",
        helperFunction.fixedDesimalNumber(Number(values.duty_vat_amt) +
          Number(values.caf) +
          Number(values.additional_fee)
      )) || setFieldValue("duty_tax", 0)
    }
  }, [values]);

  const handleReset = ()=>{
    setValues(
      {
        cost: "",
        insurance: "",
        freight: "",
        cif: "",
        duty: "",
        duty_amt: "",
        vat: "",
        vat_amt: "",
        duty_vat_amt: "",
        caf: "",
        additional_fee: "",
        duty_tax: "",
      }
    )
  }

  return (
    <div className="row w-50">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Cost</label>
                  <input
                    className={
                      "form-control" +
                      (touched.cost
                        ? !errors.cost
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("cost")}
                    placeholder="Enter Cost"
                  />
                  {/* {touched.cost && errors.cost ? (
                    <div className="text-danger">{errors.cost}</div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Insurance {"(" + data?.duty_tax_insurance_per + "%)"}</label>
                  <input
                    className={
                      "form-control" +
                      (touched.insurance
                        ? !errors.insurance
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("insurance")}
                    placeholder="Enter Insurance"
                    disabled
                  />
                  {/* {touched.insurance && errors.insurance ? (
                    <div className="text-danger">{errors.insurance}</div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Freight {"(" + data?.duty_tax_freight_per + "%)"}</label>
                  <input
                    className={
                      "form-control" +
                      (touched.freight
                        ? !errors.freight
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("freight")}
                    placeholder="Enter Freight"
                    disabled
                  />
                  {touched.freight && errors.freight ? (
                    <div className="text-danger">{errors.freight}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">CIF</label>
                  <input
                    className={
                      "form-control" +
                      (touched.cif
                        ? !errors.cif
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("cif")}
                    value={values.cif}
                    placeholder="Enter CIF"
                    disabled
                  />
                  {touched.cif && errors.cif ? (
                    <div className="text-danger">{errors.cif}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Duty %</label>
                  <input
                    className={
                      "form-control" +
                      (touched.duty
                        ? !errors.duty
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("duty")}
                    placeholder="Enter Duty %"
                  />
                  {/* {touched.duty && errors.duty ? (
                    <div className="text-danger">{errors.duty}</div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Duty Amount</label>
                  <input
                    className={
                      "form-control" +
                      (touched.duty_amt
                        ? !errors.duty_amt
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("duty_amt")}
                    placeholder="Enter Duty Amount"
                    disabled
                  />
                  {touched.duty_amt && errors.duty_amt ? (
                    <div className="text-danger">{errors.duty_amt}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Vat %</label>
                  <input
                    className={
                      "form-control" +
                      (touched.vat
                        ? !errors.vat
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("vat")}
                    placeholder="Enter Vat %"
                  />
                  {/* {touched.vat && errors.vat ? (
                    <div className="text-danger">{errors.vat}</div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Vat Amount</label>
                  <input
                    className={
                      "form-control" +
                      (touched.vat_amt
                        ? !errors.vat_amt
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("vat_amt")}
                    placeholder="Enter Vat Amount"
                    disabled
                  />
                  {touched.vat_amt && errors.vat_amt ? (
                    <div className="text-danger">{errors.vat_amt}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Duty & Vat Amount</label>
                  <input
                    className={
                      "form-control" +
                      (touched.duty_vat_amt
                        ? !errors.duty_vat_amt
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("duty_vat_amt")}
                    placeholder="Enter Duty & Vat Amount"
                    disabled
                  />
                  {touched.duty_vat_amt && errors.duty_vat_amt ? (
                    <div className="text-danger">{errors.duty_vat_amt}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">CAF {"(" + data?.caf + "%)"}</label>
                  <input
                    className={
                      "form-control" +
                      (touched.caf
                        ? !errors.caf
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("caf")}
                    placeholder="CAF"
                    disabled
                  />
                  {touched.caf && errors.caf ? (
                    <div className="text-danger">{errors.caf}</div>
                  ) : null}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Additional Fee</label>
                  <input
                    className={
                      "form-control" +
                      (touched.additional_fee
                        ? !errors.additional_fee
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    disabled
                    {...getFieldProps("additional_fee")}
                    placeholder="Enter Additional Fee"
                  />
                  {/* {touched.additional_fee && errors.additional_fee ? (
                    <div className="text-danger">{errors.additional_fee}</div>
                  ) : null} */}
                </div>
                <div className="mb-3 col-12 d-flex align-items-centerr">
                  <label className="form-label col-sm-4">Final Duty & Taxes Amt</label>
                  <input
                    className={
                      "form-control" +
                      (touched.duty_tax
                        ? !errors.duty_tax
                          ? " is-valid"
                          : " is-invalid"
                        : "")
                    }
                    {...getFieldProps("duty_tax")}
                    placeholder="Enter Final Duty & Taxes Amt"
                    disabled
                  />
                  {touched.duty_tax && errors.duty_tax ? (
                    <div className="text-danger">{errors.duty_tax}</div>
                  ) : null}
                </div>
              </div>

              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => handleReset()}
                >
                  Reset
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Loader isShow={loader} />
    </div>
  );
};

export default DutyAndTaxCalculator;
